// pages/NhaVuon/Cap4/index.tsx
// Trang Nhà Vườn Cấp 4 — CLEAN: chỉ dùng hook + components

import { useState } from 'react'
import { PageHero, ProjectGrid, CtaSection, Pagination } from '../../../../components'
import { useProjects } from '../../../../features/projects/hooks/useProjects'
import { nhaVuonCap4Projects } from '../../../../data/nhaVuonProjects'
import useDocumentTitle from '../../../../hooks/useDocumentTitle'
import './NhaVuonCap4.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Công trình thiết kế', path: '/cong-trinh-thiet-ke' },
  { label: 'Nhà vườn', path: '/nha-vuon' },
  { label: 'Cấp 4 / Nhà 1 tầng' },
]

const NhaVuonCap4Page = () => {
  useDocumentTitle('Nhà Vườn Cấp 4 - Nhà 1 Tầng - MAXCONST')
  
  useState(() => {
    try {
      sessionStorage.setItem('lastVisitedList', '/nha-vuon/nha-vuon-cap-4-nha-1-tang')
      sessionStorage.setItem('lastVisitedListName', 'Nhà vườn cấp 4')
    } catch (e) {
      // ignore
    }
  })

  const {
    currentProjects,
    loading,
    error,
    currentPage,
    totalPages,
    totalCount,
    startIndex,
    endIndex,
    setCurrentPage,
    goToNextPage,
    goToPrevPage,
    getPageNumbers,
  } = useProjects({
    category: 'cap4',
    pages: 10,
  })

  return (
    <div className="nha-vuon-cap4-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Nhà Vườn"
        title="Nhà Vườn Cấp 4 / Nhà Một Tầng"
        titleHighlight="Nhà Vườn Cấp 4"
        description="Khám phá hàng trăm mẫu nhà vườn cấp 4 đẹp, thiết kế hiện đại, phù hợp mọi diện tích và phong cách sống"
        breadcrumbs={BREADCRUMBS}
        stats={
          totalCount > 0
            ? [
                { number: `${totalCount}+`, label: 'Mẫu thiết kế' },
                { number: '10+', label: 'Năm kinh nghiệm' },
                { number: '100%', label: 'Cam kết chất lượng' },
              ]
            : undefined
        }
      />

      {/* Content */}
      <div className="container section">
        {/* Projects Grid */}
        <ProjectGrid
          projects={currentProjects}
          loading={loading}
          error={error}
        />

        {/* Pagination */}
        {!loading && !error && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            startIndex={startIndex}
            endIndex={endIndex}
            getPageNumbers={getPageNumbers}
            onPageChange={setCurrentPage}
            onPrev={goToPrevPage}
            onNext={goToNextPage}
          />
        )}

        {/* CTA */}
        <CtaSection
          title="Bạn Quan Tâm Đến Mẫu Nhà Này?"
          titleHighlight="Mẫu Nhà"
          description="Liên hệ ngay để được tư vấn chi tiết về thiết kế, báo giá và tiến độ thi công"
        />
      </div>
    </div>
  )
}

export default NhaVuonCap4Page
